// this file added by Bearer Web Developer
import React from 'react';
import { Button } from '@mui/material';
import styles from './stepOne.module.scss';
import { useAppState } from '../../../states/app-state';
import { observer } from 'mobx-react-lite';
import AccountForm from './accountForm';
import { useThemeMode } from '../../../states/contexts/theme'; // added by Bearer Web Developer


const StepOne: React.FC = observer(() => {
    const appState = useAppState();
    const { createAccount } = appState;
    const handleClose = () => {
        if (createAccount?.complete_registeration) return;
        createAccount?.setOpen(false);
    }
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.main}  data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <div className={styles.header}>
                <h5>Create Account</h5>
                <div className={styles.step_content}>
                    <div className={styles.step_number}><span>1</span>/2</div>
                    <Button className={styles.back} onClick={handleClose}>
                        {theme === 'dark' ? <img src="/back-white.svg" alt="back" /> : <img src="/back.png" alt="back" />}
                    </Button>
                </div>
            </div>
            <p>Enter your details to register.</p>
            <AccountForm />
            <div className={styles.step_show}><div className={styles.fill}></div></div>
        </div>
    )
});
export default StepOne;